<template>
  <b-container fluid class="mb-4" id="post-page">
    <b-form-textarea
      v-if="post.is_shared"
      v-model="editablePost.description"
      class="post-textarea"
      id="textarea-no-resize"
      placeholder="Write here or use @ to tag someone"
      rows="3"
      no-resize
      name="content"
      :class="{ 'is-danger': errors.has('content') }"
      @keydown="tagUser"
    ></b-form-textarea>
    <b-form-textarea
      v-else
      v-model="editablePost.content"
      class="post-textarea"
      id="textarea-no-resize"
      placeholder="Write here or use @ to tag someone"
      rows="3"
      no-resize
      name="content"
      :class="{ 'is-danger': errors.has('content') }"
      @keydown="tagUser"
    ></b-form-textarea>
    <div class="main-post-box">
      <div class="box">
        <UploadVideo
          v-if="showVideo && !post.is_shared"
          v-model="videoUrl"
          @isUrlValid="checkUrlVideoValidation"
        />
        <UploadImg
          v-if="!post.is_shared"
          v-model="images"
          :resetUploaders="resetUploaders"
          @resetDone="resetUploaders = false"
          @addToTrash="addToTrash"
        />
        <button @click="saveChanges" class="post-input-button">Post</button>
      </div>
      <UserTagSelect v-model="isOpenTag" @tag-user-post="addPostTag" />
    </div>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import UploadImg from './UploadImg.vue';
import UploadVideo from './UploadVideo.vue';
import UserTagSelect from './UserTagSelect.vue';

export default {
  components: {
    UserTagSelect,
    UploadImg,
    UploadVideo,
  },
  props: {
    post: { type: Object, default: () => {} },
  },
  data() {
    return {
      showVideo: true,
      video: null,
      images: [],
      videoUrl: '',
      isVideoUrlValid: false,
      isOpenTag: false,
      tagIndex: null,
      text: '',
      items: [],
      tagedUsers: {},
      resetUploaders: false,
      editablePost: {
        id: null,
        content: null,
        description: null,
        media: [],
        tagged_customers: [],
        tagged_persons: [],
        share_tagged_customers: [],
        tags: [],
        user: null,
      },
      imageTrash: [],
    };
  },
  mounted() {
    try {
      if (this.post.media.length) {
        if (this.post.media[0].media_type === 'video') {
          this.videoUrl = this.post.media[0].video_field;
          this.video = this.videoUrl;
        }
        this.images = this.post.media.filter(
          ({ media_type }) => media_type === 'image',
        );
        this.images = this.images.map(image => image.image_field);
      }
      if (this.post.is_shared) {
        delete this.editablePost.content;
        this.editablePost.share_tagged_customers = {
          ...this.post.share_tagged_customers,
        };
        this.editablePost.description = this.post.description;
        this.editablePost.id = this.post.shared_post_id;
      } else {
        this.editablePost.id = this.post.id || this.post.post_details.id;
        this.editablePost.tagged_customers = { ...this.post.tagged_customers };
        this.editablePost.content = this.post.content;
      }
      this.editablePost.user = this.post.user;
      this.editablePost.tags = [...this.post.tags];
    } catch (err) {
      console.log('err', err);
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'user/fetchUserInfo',
    }),
  },
  methods: {
    checkUrlVideoValidation(value) {
      this.isVideoUrlValid = value;
    },
    tagUser(simbol) {
      this.tagIndex = simbol.srcElement.selectionEnd;
    },
    ...mapActions({
      editPost: 'posts/editPost',
      editSharedPost: 'posts/editSharedPost',
      createPostMedia: 'posts/createPostMedia',
      editPostMedia: 'posts/editPostMedia',
      deletePostMedia: 'posts/deletePostMedia',
    }),
    addToTrash(index) {
      this.imageTrash.push({ id: this.post.media[index].id, url: this.post.media[index].url });
    },
    async saveChanges() {
      try {
        const isVideoUrlValid = !(this.videoUrl.length && !this.isVideoUrlValid);

        this.imageTrash.forEach(async ({ id, url }) => {
          await this.deletePostMedia({ id, url, post: this.post.url }).catch((err) => {
            throw new Error(err);
          });
        });
        if (this.images.length) {
          this.images.forEach(async (image) => {
            if (!image.startsWith('http')) {
              await this.createPostMedia({
                post: this.post.url,
                media_type: 'image',
                image_field: image,
              }).catch((err) => {
                throw new Error(err);
              });
            }
          });
        }

        if (isVideoUrlValid) {
          if (this.videoUrl !== this.video && this.video !== null) {
            await this.editPostMedia({
              post: this.post.url,
              video_field: this.videoUrl,
              media_type: 'video',
              id: this.post.media[0].id,
            }).catch((err) => {
              throw new Error(err);
            });
          } else if (this.videoUrl && this.video == null) {
            await this.createPostMedia({
              post: this.post.url,
              video_field: this.videoUrl,
              media_type: 'video',
            }).catch((err) => {
              throw new Error(err);
            });
          }
        } else {
          this.$emit('postUpdated', 'error');
          return;
        }


        if (Object.keys(this.tagedUsers).length) {
          const taggedCustomers = [];
          if (this.post.is_shared) {
            for (const [key, value] of Object.entries(this.tagedUsers)) {
              if (this.editablePost.description.includes(key)) {
                taggedCustomers.push(value);
              }
            }
            this.editablePost.share_tagged_customers = taggedCustomers;
            const taggedPersons = this.editablePost.share_tagged_customers.map(
              ({ customer_id }) => customer_id,
            );
            this.editablePost.tagged_customers = taggedPersons;
          } else {
            for (const [key, value] of Object.entries(this.tagedUsers)) {
              if (this.editablePost.content.includes(key)) {
                taggedCustomers.push(value);
              }
            }
            this.editablePost.tagged_customers = taggedCustomers;
            const taggedPersons = this.editablePost.tagged_customers.map(
              ({ customer_id }) => customer_id,
            );
            this.editablePost.tagged_persons = taggedPersons;
          }
        }

        if (this.editablePost.content || this.editablePost.description || this.videoUrl) {
          if (this.post.is_shared && this.editablePost.description !== this.post.description) {
            await this.editSharedPost(this.editablePost).catch((err) => {
              throw new Error(err);
            });
          }
          if (!this.post.is_shared && this.editablePost.content !== this.post.content) {
            await this.editPost(this.editablePost).catch((err) => {
              throw new Error(err);
            });
          }
        } else {
          this.$emit('postUpdated', 'warning');
          return;
        }

        this.$emit('postUpdated', 'success');

        this.resetData();
      } catch (err) {
        this.$emit('postUpdated', 'error');
        console.log('Error', err);
      }
    },
    addPostTag(data) {
      if (this.editablePost.content) {
        this.editablePost.content = `${this.editablePost.content.slice(
          0,
          this.tagIndex + 1,
        )}${data.full_name} ${this.editablePost.content.slice(
          this.tagIndex + 1,
        )}`;
        this.tagedUsers[`${data.full_name}`] = data;
      } else if (this.editablePost.description) {
        this.editablePost.description = `${this.editablePost.description.slice(
          0,
          this.tagIndex + 1,
        )}${data.full_name} ${this.editablePost.description.slice(
          this.tagIndex + 1,
        )}`;
        this.tagedUsers[`${data.full_name}`] = data;
      }
    },
    resetData() {
      this.images = [];
      this.video = '';
      this.editablePost.content = '';
      this.tagedUsers = {};
      this.videoUrl = '';
      this.$validator.reset();
      this.resetUploaders = true;
    },
  },
  watch: {
    images() {
      if (this.images.length) this.showVideo = false;
      else this.showVideo = true;
    },
    'editablePost.content': {
      handler(val) {
        if (
          val === '@'
          || val.slice(this.tagIndex - 1, this.tagIndex + 1) === ' @'
          || val.slice(this.tagIndex - 1, this.tagIndex + 1) === '\n@'
        ) {
          this.isOpenTag = true;
        }
      },
    },
    'editablePost.description': {
      handler(val) {
        if (
          val === '@'
          || val.slice(this.tagIndex - 1, this.tagIndex + 1) === ' @'
          || val.slice(this.tagIndex - 1, this.tagIndex + 1) === '\n@'
        ) {
          this.isOpenTag = true;
        }
      },
    },
  },
};
</script>
<style >
.mention-item {
  padding: 4px 10px;
  border-radius: 4px;
}

.mention-selected {
  background: rgb(192, 250, 153);
}
</style>

<style scoped>
#post-page {
  background-color: white;
  padding: 0;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
}

.post-textarea {
  width: 100%;
  border-radius: 0 10px 0 0;
}

.video-upload {
  margin-right: 10px;
}
.box {
  padding: 32px 14px 8px 24px;
  margin-bottom: 2px;
}
.form-control {
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #d6dad6;
  box-shadow: 0px 0px 0px 0px;
  padding: 11px 1px 1px 14px;
}
::placeholder {
  resize: none;
  font-size: 14px;
  font-family: arial;
}
.post-input-button {
  border-radius: 2px;
  float: right;
  background: #bd9d5f;
  border: none;
  color: white;
  width: 50px;
  margin-top: -24px;
  font-size: 15px;
}
.text-images {
  width: 92px;
  float: left;
  cursor: pointer;
  color: #666666;
  font-size: 12px;
  margin-bottom: 0;
}

.text-videos {
  width: 248px;
  cursor: pointer;
  margin-bottom: 4px;
  color: #666666;
  font-size: 12px;
}
.field-text {
  font-family: Arial;
  font-size: 12px;
  text-align: left;
  color: #ff0000;
  transition: 0.5s;
}
</style>
